import atomize from "@quarkly/atomize";
import { commonTextProps, commonTextPropsDefaults } from "./text";
export default atomize.u({
  name: "U",
  normalize: true,
  mixins: true,
  description: {
    en: "Text element — text in different variants: paragraph, heading, etc.",
    ru: "Элемент text — текст в различных вариантах: параграф, заголовок, и другие"
  },
  propInfo: commonTextProps
}, commonTextPropsDefaults);